import { Fragment, useState } from "react";
import { Table } from "reactstrap";
import { DetailedAlert } from "../../../components/DetailedAlert";
import { Toolbar } from "../../../components/Toolbar";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { AdministrateToggle } from "../../components/AdministrateToggle";
import { useUpdatePermission } from "../../utils";
import { AddBoxDirectoryModal } from "./AddBoxDirectoryModal";
import { EditBoxDirectoryModal } from "./EditBoxDirectoryModal";
import { extractErrorMessage } from "../../../util/api";

export const BoxSettings = ({ resource, resourcePath, refresh, tabName, tab_key }) => {
  const [message, setMessage] = useState(null);
  const [canUpdate] = useUpdatePermission("BoxDirectory");

  const setError = setMessage;

  const onAction = (results) => {
    window.localStorage.setItem(tab_key, tabName);
    setMessage(results.meta.message);
    refresh();
  };

  return (
    <>
      {canUpdate && (
        <Toolbar className="align-items-center mb-3">
          <Toolbar className="ms-auto">
            <AddBoxDirectoryModal resourcePath={resourcePath} onAdd={onAction} />
          </Toolbar>
        </Toolbar>
      )}

      {message && <DetailedAlert message={message} messageStyle="info" alertLinkClass="alert-link ms-2" />}

      <Table>
        <thead>
          <tr>
            <th>Box Folder Id</th>
            <th>Sweep Enabled</th>
            <th>Tilde Delimited File</th>
            <th>Keep File in Directory</th>
            {canUpdate && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {resource.boxDirectories?.map((boxDirectory) => {
            return (
              <Fragment key={boxDirectory.id}>
                <tr>
                  <td>{boxDirectory.box_folder_id}</td>
                  <td>
                    <AdministrateToggle
                      id={`box-toggle-${boxDirectory.id}`}
                      toggle={boxDirectory.enabled}
                      endpoint={`${resourcePath}/box_directories/${boxDirectory.id}`}
                      params={(toggle) => {
                        return { boxDirectory: { id: boxDirectory.id, enabled: toggle } };
                      }}
                      onChange={setMessage}
                      onError={setMessage}
                      disabled={!canUpdate}
                    />
                  </td>
                  <td>
                    <AdministrateToggle
                      id={`box-tilde-toggle-${boxDirectory.id}`}
                      toggle={boxDirectory.tilde_delimited_file}
                      endpoint={`${resourcePath}/box_directories/${boxDirectory.id}`}
                      params={(toggle) => {
                        return { boxDirectory: { id: boxDirectory.id, tilde_delimited_file: toggle } };
                      }}
                      onChange={setMessage}
                      onError={setMessage}
                      disabled={!canUpdate}
                    />
                  </td>
                  <td>
                    <AdministrateToggle
                      id={`box-keep-file-toggle-${boxDirectory.id}`}
                      toggle={boxDirectory.keep_file_in_directory}
                      endpoint={`${resourcePath}/box_directories/${boxDirectory.id}`}
                      params={(toggle) => {
                        return { boxDirectory: { id: boxDirectory.id, keep_file_in_directory: toggle } };
                      }}
                      onChange={setMessage}
                      onError={setMessage}
                      disabled={!canUpdate}
                    />
                  </td>
                  {canUpdate && (
                    <td>
                      <EditBoxDirectoryModal resourcePath={resourcePath} onEdit={onAction} boxDirectory={boxDirectory} />
                      <AdministrateResourceDeleteButton
                        deleteUrl={`${resourcePath}/box_directories/${boxDirectory.id}`}
                        onError={(err) => setError(extractErrorMessage(err))}
                        onSuccess={(results) => {
                          window.localStorage.setItem(tab_key, tabName);
                          setMessage(`Successfully removed Box directory ${boxDirectory.box_folder_id}`);
                          refresh();
                        }}
                      />
                    </td>
                  )}
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};
